export default __webpack_public_path__ + "static/media/certificate.ce6bb472.svg";